import firebase from "firebase/compat/app";
export async function _getRealtimeDoc(collectionName: string, docId: string) {
  firebase.database().ref(collectionName).child(docId);
}
